import css from 'styled-jsx/css'

export const LayoutStyle = css.global`
  .wrapper {
    max-width: 1920px;
    margin-left: auto;
    margin-right: auto;
  }
  .wrapper-container {
    max-width: 1170px;
    padding-left: 15px;
    padding-right: 15px;
    margin-left: auto;
    margin-right: auto;
    height: 100%;
  }
  .wrapper-container-job {
    max-width: 996px;
    margin-left: auto;
    margin-right: auto;
  }
  @media screen and (max-width: 768px) {
    .wrapper-container {
      max-width: 720px;
    }
  }
`
